import { Flex, Text, IconButton, CloseButton } from "@chakra-ui/react";
import { LuSearch } from "react-icons/lu";
import { useNavigate } from "react-router-dom";

export default function HeaderTools({
  title,
  onClickSearch,
  showSearch = false,
  backTo = "/painel",
}) {
  const navigate = useNavigate();

  return (
    <Flex
      width="100%"
      padding="20px"
      borderBottom="1px solid #e0e0e0"
      justifyContent="space-between"
      alignItems="center"
      bg="white"
      boxShadow="0 2px 4px rgba(0, 0, 0, 0.1)"
    >
      <Flex gap="10px" alignItems="center">
        <CloseButton onClick={() => navigate(backTo)} />
        <Text fontSize="24px" fontWeight="bold" color="#333">
          {title}
        </Text>
      </Flex>
      {showSearch && (
        <IconButton aria-label="Search database" onClick={onClickSearch}>
          <LuSearch />
        </IconButton>
      )}
    </Flex>
  );
}
